import { __assign, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { getIconPosition } from './getIconPosition';
import { correctIconPosition } from './correctIconPosition';
export var breakpoints = [16, 20, 24, 32, 64];
export var weights = ['light', 'regular', 'solid'];
export var MAX_LIGHT_POSITION = 1;
export var MAX_REGULAR_POSITION = 4;
export var MAX_SOLID_POSITION = 2;
export var DEFAULT_ICON_SIZE = 16;
export var DEFAULT_ICON_WEIGHT = 'regular';
export var IconDataTids = {
    root: 'Icon__root',
};
export var Icon = forwardRef(function (_a, ref) {
    var sizes = _a.sizes, style = _a.style, _b = _a.size, size = _b === void 0 ? DEFAULT_ICON_SIZE : _b, _c = _a.weight, weight = _c === void 0 ? DEFAULT_ICON_WEIGHT : _c, _d = _a.align, align = _d === void 0 ? 'center' : _d, color = _a.color, rest = __rest(_a, ["sizes", "style", "size", "weight", "align", "color"]);
    var iconPosition = getIconPosition(size, breakpoints);
    var correctedPosition = correctIconPosition(iconPosition, weight);
    var viewBoxSize = breakpoints[correctedPosition];
    var Icon = sizes[viewBoxSize][weight];
    return (React.createElement(Icon, __assign({ ref: ref, style: style, size: size, viewBoxSize: viewBoxSize, weight: weight, color: color, align: align }, rest)));
});
Icon.displayName = 'Icon';
